module.exports = __webpack_public_path__ + "static/media/lockIcon.5cd3ee4f.svg";